<template>
  <div id="base-app">
    <snackbar-wrapper />
    <transition name="component-fade" mode="out-in">
      <component :is="layout" ref="layoutComponent">
        <transition name="component-fade" mode="out-in">
          <router-view
            @triggerLoginModal="triggerLoginModal"
            @toggleSearch="toggleSearch"
            @triggerEmailVerificationModal="triggerEmailVerificationModal"
            @shownavbar="hide"
            @isFooterShow="footerShown" :style="{'padding-top': paddingTopLogin}"
            @setSearch="setSearch"
            @activateOverlay="activateOverlay"
            @defineTanyamuFloatingBtn="defineTanyamuFloatingBtn"
            @openModalRegisterOAuthForm2="openModalRegisterOAuthForm2"
            @openModalRegisterForm2="openModalRegisterForm2"
            @setMobileHeader="setMobileHeader"
          />
        </transition>
      </component>
    </transition>
    <!-- <NavbarStyle v-if="showNavbar" class="open-sans" />
    <footer-navbar class="open-sans" v-if="showNavbarkayan && showFooter" />
    <footer-copyright class="open-sans" v-if="showNavbar && showFooter" /> -->
    <modal-input-whatsapp />
    <bottom-sheet-input-whatsapp />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import scriptInjector from './functions/scriptInjector'
import deviceDetector from 'mobile-device-detect'
import MessagingService from './modules/messaging-service'
import desktopNotification from './functions/pushNotification/desktopNotification'
import CrazyEgg from '@/configs/crazyEgg'

import Navbar from './components/NewNavbar'
import FooterNavbar from './components/Footer'
import FooterCopyright from './components/FooterCopyright'

export default {
  components: {
    Navbar,
    FooterNavbar,
    FooterCopyright,
    SnackbarWrapper: defineAsyncComponent(() => import('@/components/atoms/snackbar/SnackbarWrapper.vue')),
    ModalInputWhatsapp: defineAsyncComponent(() => import('@/components/dialog/whatsapp/ModalWhatsapp.vue')),
    BottomSheetInputWhatsapp: defineAsyncComponent(() => import('@/components/dialog/whatsapp/BottomSheetWhatsapp.vue'))
  },
  data: () => ({
    showNavbar: true,
    showFooter: true,
    // isLogin: false,
    defaultLayout: 'default',
    screenWidth: window.innerWidth,
    // msgService: null,
    isMobile: deviceDetector.isMobile
  }),
  methods: {
    hide (status) {
      this.showNavbar = status
    },
    footerShown (showState) {
      this.showFooter = showState ?? true
    },
    // login (status) {
    //   this.isLogin = status
    // },
    handleResize () {
      this.screenWidth = window.innerWidth
    },
    triggerLoginModal () {
      this.$refs.layoutComponent.triggerLoginModal()
    },
    triggerEmailVerificationModal () {
      this.$refs.layoutComponent.triggerEmailVerificationModal()
    },
    toggleSearch () {
      this.$refs.layoutComponent.openInputSearch()
    },
    setSearch (value) {
      this.$refs.layoutComponent.searchNavbar(value)
    },
    activateOverlay (value) {
      this.$refs.layoutComponent.activateOverlay(value)
    },
    defineTanyamuFloatingBtn (value) {
      this.$refs.layoutComponent.defineTanyamuFloatingBtn(value)
    },
    openModalRegisterOAuthForm2 () {
      this.$refs.layoutComponent.openModalRegisterOAuthForm2()
    },
    openModalRegisterForm2 () {
      this.$refs.layoutComponent.openModalRegisterForm2()
    },
    askNotificationPermission () {
      if (Notification.permission === 'default') {
        Notification.requestPermission()
      }
    },
    async setFbMessaging () {
      this.msgService = new MessagingService()
      // Request permission
      await this.msgService.requestPermissionAsync()
      // this.isTokenSentToServer = msgService.isTokenSentToServer();
      return this.msgService.getTokenAsync()
    },
    listenFirebaseNotif () {
      if (Notification.permission === 'granted') {
        this.setFbMessaging()

        window.firebaseMessaging.onMessage((payload) => {
          this.$store.commit('notification/SET_NEW_NOTIF', true)
          desktopNotification(payload.data.title, {
            body: payload.data.body,
            image: payload.data.icon,
            icon: 'https://cdn.karier.mu/assets/home/footer_logo.svg'
          }, '/notifikasi')
        })
      }
    },
    checkIsVerificationFreeze () {
      if ((localStorage.getItem('freezing-verification-timestamp'))) {
        const countTime = new Date(Number(localStorage.getItem('freezing-verification-timestamp'))).getTime()
        const now = new Date().getTime()
        const gap = countTime - now

        if (gap > 0) {
          this.$store.commit('user/CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION', true)
          setTimeout(() => {
            this.$store.commit('user/CHANGE_UNFREEZE_VERIFICATION_SNACKBAR_TEXT_TYPE', 'wasDisabled')
            this.$store.commit('user/CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION', false)
            this.$store.commit('user/CHANGE_IS_SHOW_UNFREEZE_SNACKBAR', true)
          }, gap)
        }
      }
    },
    setMobileHeader (obj) {
      this.$refs.layoutComponent.setMobileHeader(obj)
    },
    setSourcePlatform () {
      const isPrakerjaEnv = location.hostname.toLowerCase().includes('prakerja')
      const platformType = this.isMobile ? 'mweb' : 'web'
      const platformEnv = isPrakerjaEnv ? 'prakerja' : 'kariermu'
      const sourcePlatform = `${platformType}_${platformEnv}`
      this.$store.commit('analytics/SET_SOURCE', sourcePlatform)
    },
    checkUserWhatsapp () {
      // is_phone_refilled = 0, perlu update nomor ponsel yang terdaftar di WA
      // is_phone_refilled = 1, sudah input nomor ponsel dengan WA
      if (this.userInfo?.is_phone_refilled === 1) {
        return
      }
      if (this.isShownWhatsappDialog) {
        this.$store.commit('TOGGLE_WHATSAPP_INPUT_DIALOG', true)
      }
    },
    handleBeforeInstallPrompt (event) {
      event.preventDefault()
    }
  },
  computed: {
    msgService: {
      get () {
        return this.$store.state.notification.msgService
      },
      set (value) {
        this.$store.commit('notification/SET_MSG_SERVICE', value)
      }
    },
    layout () {
      return (this.$route.meta.layout || this.defaultLayout) + '-layout'
    },
    paddingTopLogin () {
      if (
        this.$route.name === 'Sertifikat Regular' ||
          this.$route.name === 'Checkout' ||
          this.$route.name === 'payment-thankyou-page' ||
          this.$route.name === 'Resi Program' ||
          this.$route.name === 'Prakerja Receipt'
      ) {
        return '0'
      } else if (this.$route.name === 'activity-program') {
        if (this.screenWidth <= 452) return '48px'
        return '72px'
      } else if (this.$route.name === 'PaymentPrakerjaV2') {
        if (this.screenWidth <= 767) return '56px'
        return '0'
      } else {
        return '0'
      }
    },
    envBelajar () {
      return this.$store.state.envBelajar
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    isShowUnfreezeVerificationSnackbar: {
      get () {
        return this.$store.state.user.isShowUnfreezeVerificationSnackbar
      },
      set (val) {
        this.$store.commit('user/CHANGE_IS_SHOW_UNFREEZE_SNACKBAR', val)
      }
    },
    isShownWhatsappDialog () {
      const pageName = this.$route?.name?.toLowerCase()
      switch (true) {
        // 0 = tampil
        // 1 = tidak tampil
        case pageName === 'payment-thankyou-page':
          return this.userInfo?.is_phone_dismissed_payment === 0
        case pageName === 'profile':
          return this.userInfo?.is_phone_dismissed_profile === 0
        case pageName === 'programmu':
          return this.userInfo?.is_phone_dismissed_programmu === 0
        default:
          return false
      }
    },
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  watch: {
    $route () {
      this.$store.commit('user/CHANGE_IS_VERIFICATION_MANDATORY', false)
      this.$store.commit('user/CHANGE_IS_HIDE_SKIP_VERIFICATION', false)
      this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_INVITATION', false)
      this.$store.commit('user/CHANGE_IS_OPEN_VERIFICATION_OTP', false)

      if (this.userInfo.id) {
        this.checkUserWhatsapp()
      }
    },
    isShowUnfreezeVerificationSnackbar (value) {
      if (value) {
        setTimeout(() => {
          this.isShowUnfreezeVerificationSnackbar = false
        }, 10000)
      }
    },
    'userInfo.id' (value) {
      if (value) {
        // handle on page load with empty user data
        this.checkUserWhatsapp()
      }
    }
  },
  async created () {
    this.$store.commit('SET_HOST_DOMAIN')

    // setup envitonment
    this.$store.commit('SET_ACTIVE_ENVIRONMENT')
    this.$store.commit('SET_ENV_BELAJAR')
    this.$store.commit('SET_ENV_PLATINUM')
    if (this.$store.state.envPlatinum) {
      await this.$store.dispatch('institution/getInstitutionPlatinumBySubdomain')
    }

    // ask permission for notification
    // this.askNotificationPermission()

    /* global $cookies */
    /* eslint no-undef: "error" */
    if ($cookies.get('access-token')) {
      this.$store.dispatch('storage/setStorageApp')
      if (window.firebase.messaging.isSupported()) {
        this.listenFirebaseNotif()
      }
    }

    if (this.$store.state.storage.accessToken) {
      this.$store.commit('user/CHANGE_IS_LOGIN', true)
      this.$store.dispatch('notification/getNotificationCounter')
    }
    window.addEventListener('resize', this.handleResize)

    // const CLIENT_KEY = process.env.VUE_APP_CLIENT_KEY_MIDTRANS
    // const SOURCE_KEY = process.env.VUE_APP_SOURCE_SCRIPT
    // const script = document.createElement('script')
    // script.src = SOURCE_KEY
    // script.type = 'text/javascript'
    // script.setAttribute('data-client-key', CLIENT_KEY)
    // script.style.display = 'none'
    // document.head.append(script)

    // inject midtrans script
    const MIDTRANS_CLIENT_KEY = process.env.VUE_APP_CLIENT_KEY_MIDTRANS
    const TOKEN_SCRIPT = process.env.VUE_APP_MIDTRANS_TOKEN_SCRIPT
    const midtransScript = document.createElement('script')
    const DATA_ENVIRONMENT = this.$store.state.activeEnv === 'production' ? 'production' : 'sandbox'
    midtransScript.src = TOKEN_SCRIPT
    midtransScript.type = 'text/javascript'
    midtransScript.setAttribute('data-client-key', MIDTRANS_CLIENT_KEY)
    midtransScript.id = 'midtrans-script'
    midtransScript.setAttribute('data-environment', DATA_ENVIRONMENT)
    document.head.append(midtransScript)

    this.$store.dispatch('subnavbar/initMenuList')
    await this.$store.dispatch('user/fetchUserData')
    // const dataLogin = await this.$store.dispatch('user/fetchUserData')
    // if (dataLogin.status === 200) {
    //   this.$store.dispatch('tanyamu/loginQiscus')
    // }

    if (this.$store.state.activeEnv === 'production') {
      scriptInjector()
    }

    // activate PUBLISHED KEY XENDIT
    window.Xendit.setPublishableKey(process.env.VUE_APP_CLIENT_KEY_XENDIT)

    this.checkIsVerificationFreeze()

    // CrazyEgg
    const userInfo = this.$store.state.user.userInfo
    window.CE_READY = function () {
      CrazyEgg.setCrazyEggUserVariable({
        userId: userInfo ? userInfo.id : '',
        professionName: userInfo ? userInfo.profession_name : '',
        yearLevelName: userInfo ? userInfo.year_level_name : '',
        roleLabel: userInfo && userInfo.role && userInfo.role[0] ? userInfo.role[0].label : '',
        prakerjaStatus: userInfo ? userInfo.prakerja_id ? 'Prakerja User' : 'Non-Prakerja User' : ''
      })
    }
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
    if (this.msgService) {
      this.msgService.deleteTokenAsync()
    }
  },
  mounted () {
    // source platform
    this.setSourcePlatform()
    window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt)
  }
}
</script>

<style>
@import url('./styles/Tour.css');
@import url('./styles/Wysiwyg.css');
@import url('./styles/dist/FontTypes.css');
@import url('./styles/ColorStyle.css');
@import url('./styles/ModalStyle.css');
@import url('./styles/EllipsisText.css');
@import url('./styles/FontHelper.css');
@import url('./styles/ViewBreakpoint.css');
@import url('./styles/ButtonStyle.css');
@import url('./styles/Margin.css');
@import url('./styles/Sizes.css');
@import url('./styles/Utilities.css');
@import url('./styles/BorderRadius.css');
@import url('./styles/SkeletonLoader.css');

body{
  height: 100vh;
}
#base-app{
  height: 100vh;
}
*{
  color: inherit;
}
a {
  /* color: inherit; */
  text-decoration: none;
}

a.dropdown-item.active, a.dropdown-item:active {
  background-color: #ffffff !important;
}

#image-resizer img {
  width: 100%;
  object-fit: contain;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 4px;
  background: #BDBDBD;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

/* .modal-content {
  width: 340px !important;
  margin: auto;
} */

@font-face {
  font-family: "Gotham Bold";
  src: url("./assets/fonts/GothamSSm-Bold.ttf");
}

@font-face {
  font-family: "Gotham Book";
  src: url("./assets/fonts/GothamSSm-Medium.ttf");
}

@font-face {
  font-family: "Catalunya";
  src: url("./assets/fonts/Catalunya-demo.ttf");
}

@font-face {
  font-family: 'hind_gunturbold';
  src: url('./assets/fonts/Hind-Guntur/HindGuntur-Bold.ttf');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'hind_gunturlight';
  src: url('./assets/fonts/Hind-Guntur/HindGuntur-Light.ttf');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'hind_gunturmedium';
  src: url('./assets/fonts/Hind-Guntur/HindGuntur-Medium.ttf');
  font-weight: normal;
  font-style: normal;

}

@font-face {
  font-family: 'hind_gunturregular';
  src: url('./assets/fonts/Hind-Guntur/HindGuntur-Regular.ttf');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'hind_guntursemibold';
  src: url('./assets/fonts/Hind-Guntur/HindGuntur-SemiBold.ttf');
  font-weight: normal;
  font-style: normal;
}

.gotham-bold {
  font-family: "Gotham Bold";
}

.gotham-book {
  font-family: "Gotham Book";
}

.open-sans {
  font-family: "Open Sans", sans-serif;
}

.catalunya-font{
  font-family: "Catalunya";
}

.hind-guntur-bold{
  font-family: "hind_gunturbold";
}

.hind-guntur-light{
  font-family: "hind_gunturlight";
}

.hind-guntur-medium{
  font-family: "hind_gunturmedium";
}

.hind-guntur-regular{
  font-family: "hind_gunturregular";
}

.hind-guntur-semi-bold{
  font-family: "hind_guntursemibold";
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-active {
  opacity: 0;
}

:root {
  scroll-behavior: smooth;
  font-family: "Open Sans", sans-serif;
}

*:focus {
  outline: none;
}

.fade-enter-active, .fade-leave-active {
  transition: .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* ::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
  background: #3498DB;
  border-radius: 15px;
  cursor: pointer
}

::-webkit-scrollbar-thumb:hover {
  background: #3498DB;
  cursor: pointer
} */

/* ::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
  background: #3498DB;
  border-radius: 20px;
  cursor: pointer
}

::-webkit-scrollbar-thumb:hover {
  background: #3498DB;
  cursor: pointer
} */

code {
  white-space: pre
}

/* Adding class for font weight */

.font-normal{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}

.font-semibold{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}

.font-bold{
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
}

.primary-font-color{
  color: #333333;
}

.secondary-font-color{
  color: #828282;
}

.highlight-font-color{
  color: var(--highlight-font-color);
}

.white-font-color{
  color: #ffffff;
}

/* Adding CSS variable for coloring in Project */
:root{
  --todo-card-program-name-width: 375px;
  --todo-card-activity-name-width: 375px;
  --mobile-navbar-max-height: 56px;
}

.unrotate-class {
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  transition: 0.3s;
}

.rotate-class {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  transition: 0.3s;
}

.cursor-pointer {
  cursor: pointer;
}

.cropper-crop-box, .cropper-view-box {
  border-radius: 50%;
  outline: 0 !important;
}

.cropper-view-box {
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.25);
  outline: 0;
  outline-color: var( --color-ui-element-black);
}

.cropper-point {
  display: none;
}

.cropper-face {
  background: none !important;
}

.cropper-line {
  display: none !important;
}

.s-bottom-sheet-overlay {
  height: 100dvh!important;
}

@media (max-width: 512px) {
  /* Override padding for mobile version toast */
  ::v-deep(.Vue-Toastification__container.bottom-center) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
</style>
